/** Link at api endpoint for search throw faq */
const apiFaqSearch = "/api/faq/articles/";
/** Link at api analytics */

const apiAnalytics = "/api/pinacolada/";
/** Link at API endpoint for save proofreading data (page url) */

const apiPromotionOrderSave = "https://script.google.com/macros/s/AKfycby0IEESIGsCh4Qhlnx3PJrFh9VJOYElRqihtMkVONcHyGHexII-6g0NFncprHOQcVh3wQ/exec";
export { apiFaqSearch, apiAnalytics, apiPromotionOrderSave };